import PropTypes from 'prop-types';
import React from 'react';

import { READ, WRITE, SWITCHON, SWITCHOFF } from '../Om7Sense';

export function datastoreComponentConnect(Component, doFlashing) {
    return class DatastoreComponent extends React.Component {

        static contextTypes = {
            t: PropTypes.func.isRequired,
            p: PropTypes.object.isRequired,
            basePath: PropTypes.string
        }

        static defaultProps = {
            "type": "text",
            "tdClass": "",
            "unit": null,
            "readOnly": true,
            "popupName": null,
            "component": null,
            doFlashing: false

        };

        constructor(props, context) {
            super(props);
            // Construct initial state
            let newData = {
                data:null,
                labelState: null,
                isFlashing: false,
                isConfig: (!props.readOnly && props.dataPath.indexOf("config/") === 0),
                isData: (!props.readOnly && props.dataPath.indexOf("data/") === 0)
            };
            if (context.basePath !== undefined) {
                if (props.dataPath !== undefined) {
                    const fullDataPath = context.basePath + props.dataPath;
                    newData.data = context.p.getPath(fullDataPath);
                    if (!props.readOnly) {
                        newData.readOnly = !((context.p.checkPermission(SWITCHON, fullDataPath))
                        || (context.p.checkPermission(SWITCHOFF, fullDataPath))
                        || (context.p.checkPermission(WRITE, fullDataPath)))
                        || ~~newData.data?.ro;
                    }
                    newData.readable = context.p.checkPermission(READ, fullDataPath);

                }
                if (props.labelPath) {
                    newData.labelState = context.p.getPath(context.basePath + props.labelPath);
                }

                
                this.state = newData;
            } else {
                newData.data = {
                    v: null,
                    ts: 0,
                    "new": null
                };
                this.state = newData;
            }
        }

        updateInDS = (value, oldValue, relativePath, varName, path) => {
            // This might be an update that just extends the timestamp. Ignore.
            if (value.v === undefined && value.name === undefined) {
                return;
            }
            var self = this;
            if (this.props.doFlashing && !this.state.isConfig) {
                this.setState(
                    {
                        data: value,
                        isFlashing: oldValue!=null
                    }
                );
                setTimeout(function () {
                    self.setState({isFlashing: false});
                }, 1000);
            } else {
                this.setState(
                    {
                        data: value
                    }
                );
            }
        }

        updateLabelInDS = (value) => {
            this.setState({"labelState": value});
        }

        updateStorePathInDS = (value) => {
            this.setState({"data": value});
        }

        componentDidMount() {
            const nextProps = this.props;
            const self = this, p = this.context.p;

            if (nextProps.dataPath !== undefined && this.state.readable) {
                if (this.context.basePath !== undefined) {
                    var newState = {};
                    newState.isConfig = nextProps.readOnly === false;
                    newState.isData = (nextProps.dataPath.indexOf("data/") === 0);

                    if (nextProps.optional && !this.state.data) {
                        if (newState) {
                            self.setState(newState);
                        }
                        return;
                    }

                    this.subscription = p.subscribeDS(this.context.basePath + nextProps.dataPath, self.updateInDS);
                    if (!this.state.data) {
                        var currentData = p.getPath(this.context.basePath + nextProps.dataPath);

                        // console.log(" input current " + currentData, this.subscription);
                        newState.data = currentData;
                    }

                    if (newState) {
                        self.setState(newState);
                    }
                }
                if (nextProps.labelPath) {
                    this.labelSubscription = p.subscribeDS(this.context.basePath + nextProps.labelPath, this.updateLabelInDS);
                }
            }
        }

        componentWillUnmount() {
            const p = this.context.p;
            if (this.subscription) {
                p.unsubscribeDS(this.updateInDS, this.subscription);
                this.subscription = null;
            }
            if (this.labelSubscription) {
                p.unsubscribeDS(this.updateLabelInDS, this.labelSubscription);
                this.labelSubscription = null;
            }
        }

        getInputProps = () => {
            var props = {
                type: this.props.type,
            };
            if (props.type === "number") {
                if ("min" in this.props) {
                    props.min = this.props.min;
                }
                if ("max" in this.props) {
                    props.max = this.props.max;
                }
            }
            if ("size" in this.props) {
                props.size = this.props.size;
            }
            if ("maxLength" in this.props) {
                props.maxLength = this.props.maxLength;
            }
            if (this.props.readOnly) {
                props.readOnlyUpstream = this.props.readOnly;
            }
            return props;
        }

        render() {
            if ((this.props.optional && !this.state.data) || !this.state.readable) {
                return null;
            }
            if (this.state.labelState) {
                return <Component title={this.state.labelState} {...this.props} basePath={this.context.basePath} {...this.state} inputProps={this.getInputProps()} />;
            } else {
                return <Component {...this.props} basePath={this.context.basePath} {...this.state} inputProps={this.getInputProps()} />;
            }
        }
    };
};

// DatastoreComponent.;

// )

